import React, { useState } from "react";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { ColorRing } from 'react-loader-spinner'
import FileUpload from "./components/file-upload/file-upload-clinicalInfo.component";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CCR from './CCR';
import ButtonOptions from './ButtonOptions';
import Link from '@mui/material/Link';

const NonBlankTextField = ({ ...props }) => {
	const [error, setError] = useState(false);
	const [helperText, setHelperText] = useState('');


	const handleBlur = (e) => {
		// Check if the trimmed value is empty
		if (e.target.value.trim() === '') {
			setError(true);
			setHelperText('Field cannot be blank');
		} else {
			setError(false);
			setHelperText('');
		}
	};

	return (
		<TextField
			onBlur={handleBlur} // Validate on blur
			error={error}
			helperText={helperText}
			{...props}
		/>
	);
};

export default function AuthIntake() {

	const [submitIntakeResult, setSubmitIntakeResult] = useState(null);
	const [clinicalInfo, setClinicalInfo] = useState({ docs: [] });
	const [spinner, setSpinner] = useState(false);
	const [postErrorResult, setPostErrorResult] = useState(null);
	const [showEmergencyMessage, setShowEmergencyMessage] = useState(false);
	const [showCCR, setShowCCR] = useState(false);
	const [requestType, setRequestType] = useState('standard');
	const [personCalling, setPersonCalling] = useState('');
	const [email, setEmail] = useState('');
	const [callbackNumber, setCallbackNumber] = useState('');
	const [faxNumber, setFaxNumber] = useState('');
	const [patientFirstName, setPatientFirstName] = useState('');
	const [patientLastName, setPatientLastName] = useState('');
	const [groupName, setGroupName] = useState('');
	const [groupId, setGroupId] = useState('');
	const [dob, setDOB] = useState('');
	const [dos, setDOS] = useState('');
	const [doctorFirstName, setDoctorFirstName] = useState('');
	const [doctorLastName, setDoctorLastName] = useState('');
	const [doctorAddress, setDoctorAddress] = useState('');
	const [doctorNPI, setDoctorNPI] = useState('');
	const [doctorTaxId, setDoctorTaxId] = useState('');
	const [facilityName, setFacilityName] = useState('');
	const [facilityAddress, setFacilityAddress] = useState('');
	const [facilityNPI, setFacilityNPI] = useState('');
	const [facilityTaxId, setFacilityTaxId] = useState('');
	const [cptCodes, setCPTCodes] = useState('');
	const [icdCodes, setICDCodes] = useState('');
	const [levelOfCare, setLevelOfCare] = useState('');



	const updateUploadedFiles = (files) => setClinicalInfo({ ...clinicalInfo, docs: files });

	const handleSubmit = async (e) => {
		e.preventDefault();

		setSpinner(true);
		setPostErrorResult(null);
		var formData = new FormData();
		for (var i = 0; i < clinicalInfo.docs.length; i++) {
			formData.append("files", clinicalInfo.docs[i]);
		}


		const data = JSON.stringify({
			requestType: requestType,
			personCalling: personCalling,
			email: email,
			callbackNumber: callbackNumber,
			faxNumber: faxNumber,
			patientFirstName: patientFirstName.trim(),
			patientLastName: patientLastName.trim(),
			groupName: groupName,
			groupId: groupId,
			dob: dob,
			dos: dos,
			doctorFirstName: doctorFirstName,
			doctorLastName: doctorLastName,
			doctorAddress: doctorAddress,
			doctorNPI: doctorNPI,
			doctorTaxId: doctorTaxId,
			facilityName: facilityName,
			facilityAddress: facilityAddress,
			facilityNPI: facilityNPI,
			facilityTaxId: facilityTaxId,
			cptCodes: cptCodes,
			icdCodes: icdCodes,
			levelOfCare: levelOfCare
		});

		formData.append("formInfo", data);

		const requestOptions = {
			method: 'POST',
			body: formData
		};

		try {

			const res = await fetch('https://veritasallies.net/opensearch/authintake', requestOptions);
			setSpinner(false);

			if (!res.ok) {
				const message = `An error has occured: ${res.status} - ${res.statusText}`;
				throw new Error(message);
			}

			const r = await res.text();

			const result = {
				status: res.status + "-" + res.statusText,
				headers: {
					"Content-Type": res.headers.get("Content-Type"),
					"Content-Length": res.headers.get("Content-Length"),
				},
				data: r
			};

			setSubmitIntakeResult(result.data);
		} catch (err) {
			setPostErrorResult(
				<div>
					An Error Occured. Try using legacy form
					<Stack spacing={2} direction="column" sx={{ margin: 'auto', width: '50%' }}>
						<Link href="https://forms.wix.com/f/7378536050953552795">UR Form</Link>
						<Link href="https://forms.wix.com/f/7322686263469801653">Emergency UR Form</Link>
					</Stack>
				</div>
			);
			setSpinner(false);
		}
	};

	const handlePersonCallingChange = (event) => {
		setPersonCalling(event.target.value);
	};
	const handleEmailChange = (event) => {
		setEmail(event.target.value);
	};
	const handleCallbackNumberChange = (event) => {
		setCallbackNumber(event.target.value);
	};

	const handleFaxNumberChange = (event) => {
		setFaxNumber(event.target.value);
	};
	const handlePatientFirstNameChange = (event) => {
		setPatientFirstName(event.target.value);
	};
	const handlePatientLastNameChange = (event) => {
		setPatientLastName(event.target.value);
	};

	const handleGroupNameChange = (event) => {
		setGroupName(event.target.value);
	};
	const handleGroupIdChange = (event) => {
		setGroupId(event.target.value);
	};

	const handleDOBChange = (event) => {
		setDOB(event.target.value);
	};
	const handleDOSChange = (event) => {
		setDOS(event.target.value);
	};

	const handleDoctorFirstNameChange = (event) => {
		setDoctorFirstName(event.target.value);
	};
	const handleDoctorLastNameChange = (event) => {
		setDoctorLastName(event.target.value);
	};
	
	const handleDoctorAddressChange = (event) => {
		setDoctorAddress(event.target.value);
	};
		
	const handleDoctorNPIChange = (event) => {
		setDoctorNPI(event.target.value);
	};

	const handleDoctorTaxIdChange = (event) => {
		setDoctorTaxId(event.target.value);
	};
	const handleFacilityNameChange = (event) => {
		setFacilityName(event.target.value);
	};
	
	const handleFacilityAddressChange = (event) => {
		setFacilityAddress(event.target.value);
	};
	
	const handleFacilityNPIChange = (event) => {
		setFacilityNPI(event.target.value);
	};

	const handleFacilityTaxIdChange = (event) => {
		setFacilityTaxId(event.target.value);
	};
	const handleCPTCodesChange = (event) => {
		setCPTCodes(event.target.value);
	};
	const handleICDCodesChange = (event) => {
		setICDCodes(event.target.value);
	};

	const handleLevelOfCareChange = (event) => {
		if (event.target.checked) {
			setLevelOfCare(event.target.name);
		}
	};

	const handleRequestTypeChange = (event) => {
		if (event.target.checked) {
			setRequestType(event.target.value);
		}
		if (event.target.value === 'emergency') {
			setShowEmergencyMessage(true);
			setShowCCR(false);
		} else if (event.target.value === 'ccr') {
			setShowCCR(true);
			setShowEmergencyMessage(false);
		} else {
			setShowCCR(false);
			setShowEmergencyMessage(false);
		}
	};




	return (
		<div sx={{ justifyContent: "center" }}>
			{showCCR && (
				<CCR
					requestType={requestType}
					showEmergencyMessage={showEmergencyMessage}
					handleRequestTypeChange={handleRequestTypeChange} />)}
			{!showCCR && submitIntakeResult && <div className="alert alert-secondary mt-2" role="alert"><h2>{submitIntakeResult}</h2></div>}
			{!showCCR && !submitIntakeResult && (
				<form onSubmit={handleSubmit}>
					<Stack spacing={2} direction="column" sx={{ margin: 'auto', width: '50%' }}>
						<div>
							<h2> UTILIZATION REVIEW INFORMATION </h2>
							<h3> *** IMPORTANT *** </h3>
							<h4> Please allow 24 business hours after submission for a response </h4>

							Elective procedures should be submitted a minimum of 5 business days prior to procedure date
						</div>

						<ButtonOptions
							requestType={requestType}
							showEmergencyMessage={showEmergencyMessage}
							handleRequestTypeChange={handleRequestTypeChange}
						/>

						<NonBlankTextField id="outlined-basic" label="Person Calling" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={personCalling}
							onChange={handlePersonCallingChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Email" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={email}
							onChange={handleEmailChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Callback Number w/ Ext" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={callbackNumber}
							onChange={handleCallbackNumberChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Fax Number" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={faxNumber}
							onChange={handleFaxNumberChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Patient First Name" variant="outlined"
							placeholder="ATTENTION PATIENT INFO GOES HERE"
							InputLabelProps={{
								shrink: true,
							}}
							inputProps={
								{
									sx: {
										'&::placeholder': {
											color: 'red',
											opacity: 1, // otherwise firefox shows a lighter color
										},
									},
								}
							}
							value={patientFirstName}
							onChange={handlePatientFirstNameChange}
						/>
						<NonBlankTextField id="outlined-basic" label="Patient Last  Name" variant="outlined"
							placeholder="ATTENTION PATIENT INFO GOES HERE"
							InputLabelProps={{
								shrink: true,
							}}
							inputProps={
								{
									sx: {
										'&::placeholder': {
											color: 'red',
											opacity: 1, // otherwise firefox shows a lighter color
										},
									},
								}
							}
							value={patientLastName}
							onChange={handlePatientLastNameChange}
						/>
						<NonBlankTextField id="outlined-basic" label="Group Name" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={groupName}
							onChange={handleGroupNameChange}
						/>
						<NonBlankTextField id="outlined-basic" label="Group ID" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={groupId}
							onChange={handleGroupIdChange}
						/>
						<NonBlankTextField
							id="dateOfBirth"
							label="Date of Birth"
							type="date"

							InputLabelProps={{
								shrink: true,
							}}
							value={dob}
							onChange={handleDOBChange}
							required
						/>
						<NonBlankTextField
							id="dateOfService"
							label="Date of Service"
							type="date"

							InputLabelProps={{
								shrink: true,
							}}
							value={dos}
							onChange={handleDOSChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Ordering Doctor First Name" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={doctorFirstName}
							onChange={handleDoctorFirstNameChange}
						/>
						<NonBlankTextField id="outlined-basic" label="Ordering Doctor Last Name" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={doctorLastName}
							onChange={handleDoctorLastNameChange}
						/>
						<NonBlankTextField id="outlined-basic" label="Ordering Doctor Address" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={doctorAddress}
							onChange={handleDoctorAddressChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Ordering Doctor NPI" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={doctorNPI}
							onChange={handleDoctorNPIChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Ordering Doctor TaxId" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={doctorTaxId}
							onChange={handleDoctorTaxIdChange}
							required
						/>
						<TextField id="outlined-basic" label="Facility Name" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={facilityName}
							onChange={handleFacilityNameChange}
						/>
						<TextField id="outlined-basic" label="Facility Address" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={facilityAddress}
							onChange={handleFacilityAddressChange}
							required
						/>						
						<NonBlankTextField id="outlined-basic" label="Facility NPI" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={facilityNPI}
							onChange={handleFacilityNPIChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="Facility TaxId" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={facilityTaxId}
							onChange={handleFacilityTaxIdChange}
							required
						/>
						<NonBlankTextField id="outlined-basic" label="CPT/HCPCS Codes" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={cptCodes}
							onChange={handleCPTCodesChange}
						/>
						<NonBlankTextField id="outlined-basic" label="ICD 10 Codes" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							value={icdCodes}
							onChange={handleICDCodesChange}
						/>


						<FormGroup>
							<FormControlLabel control={<Checkbox />} name="Outpatient" label="Outpatient" onChange={handleLevelOfCareChange} />
							<FormControlLabel control={<Checkbox />} name="Observation" label="Observation" onChange={handleLevelOfCareChange} />
							<FormControlLabel control={<Checkbox />} name="Inpatient" label="Inpatient" onChange={handleLevelOfCareChange} />
						</FormGroup>


						<FileUpload
							accept=".pdf,image/*"
							label="Upload Clinical Information"
							multiple
							updateFilesCb={updateUploadedFiles}
						/>
					</Stack>
					<Stack spacing={2} direction="row" sx={{ margin: 'auto', width: '50%' }}>
						<Button variant="outlined" type="submit">Submit</Button>
						<ColorRing
							visible={spinner}
							height="80"
							width="80"
							ariaLabel="blocks-loading"
							wrapperStyle={{}}
							wrapperClass="blocks-wrapper"
							colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
						/>
						<center><h2>{postErrorResult && <div className="alert alert-secondary mt-2" role="alert"><pre>{postErrorResult}</pre></div>}</h2></center>
					</Stack>
				</form>
			)}
		</div >
	);
}